export const RETIRO_25_POST_EXITOSO = "RETIRO_25_POST_EXITOSO";
export const RETIRO_25_POST_ERROR = "RETIRO_25_POST_ERROR";
export const RETIRO_25_POST_LOGIN = "RETIRO_25_POST_LOGIN";
export const RETIRO_25_CLEAR = "RETIRO_25_CLEAR";
export const RETIRO_25_CLEAR_PARCIAL = "RETIRO_25_CLEAR_PARCIAL";